import currency from 'currency.js';

/** Формат денег для UI: разряды ru-RU + «₽», без копеек (125 000 ₽). */
export const formatMoney = (n: number): string => `${ new Intl.NumberFormat('ru-RU').format(n) } ₽`;

export const getTotalAmountString = (invoiceAmount?: number, invoiceDiscount?: number): string => {
  return currency(invoiceAmount).subtract(invoiceDiscount).toString();
};

export const getTotalAmountNumber = (invoiceAmount?: number, invoiceDiscount?: number): currency => {
  return currency(invoiceAmount).subtract(invoiceDiscount);
};
